import { ShowMoreButton } from "ComponentsUI/Buttons";
import { FILTER_TYPES } from "Containers/TariffsFilterContainer";
import Container from "reactstrap/lib/Container";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import withDefaultParams from "Services/withDefaultParams";
import { pipe } from "Utils/functionalUtils";
import { Redirect404 } from "ComponentsUI/Redirects";
import MobileTariffList from "ComponentsUI/MobileTariffList";
import { FiltersTariffsStub } from "designSystem/Stubs";
import { ResetFiltersBlock } from "designSystem/EmptyContentBlocks/ResetFiltersBlock";
import { ShouldAddConvergentProvider } from "providers/shouldAddConvergentProvider";
import TariffsFilterContainer from "../../Containers/TariffsFilterContainer";
import { useFiltersTariffs } from "../hooks";

const MINUTES_RANGE_STEP = 10;

const Tariffs = (props) => {
	const {
		ApplicationModel: {
			windowSizeModel: { windowSizes },
			text,
			mobileFiltersTouchModel,
		},
		match: { params },
		location: { search },
	} = props;
	const {
		tariffs,
		totalTariffs,
		fetchMoreTariffs,
		isTariffsLoading,
		initalFilters,
		currentFilters,
		setFilters,
		resetFilters,
		currentOperator,
	} = useFiltersTariffs(search);

	const [filtersItems, setFiltersItems] = useState(null);

	useEffect(() => {
		if (!initalFilters) {
			return;
		}

		setFiltersItems([
			{
				type: FILTER_TYPES.SELECT,
				props: {
					title: text.OPERATOR,
					placeholder: text.CHOOSE_OPERATOR,
					activePlaceHolder: text.CHOOSE_OPERATOR,
					items: initalFilters.operators,
					findItems: currentOperator && [currentOperator],
					onItemSelect: ([provider]) => {
						setFilters(initalFilters, {
							providers: provider,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputName: "change_operators",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.minutes,
					title: text.MINUTES,
					value: currentFilters.minutes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							minutes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							minutes: null,
						});
					},
					step: MINUTES_RANGE_STEP,
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_minutes_min",
					inputNameMax: "change_minutes_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.gigabytes,
					title: text.INTERNET,
					value: currentFilters.gigabytes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							gigabytes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							gigabytes: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_gb_min",
					inputNameMax: "change_gb_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.price,
					title: text.SUBSCRIPTION_FEE,
					value: currentFilters.price,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							price: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							price: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_price_min",
					inputNameMax: "change_price_max",
				},
			},
		]);
	}, [
		currentFilters.gigabytes,
		currentFilters.minutes,
		currentFilters.price,
		initalFilters,
		setFilters,
		text,
		currentOperator,
		mobileFiltersTouchModel,
	]);

	// if (isTariffsLoading) {
	//     return <FiltersTariffsStub />;
	// }

	// Проверка, если нет тарифов на 2 тегах, то 404.
	if (
		params.regionUrlComing === "operatory" ||
		((params.tagCode === "korporativnyj" || params.tagCode === "bez-interneta") && !tariffs.length)
	) {
		return (
			<Redirect404
				message404={"Выбран тег korporativnyj/bez-interneta в регионе на котором нет тарифов"}
			/>
		);
	}

	return (
		<>
			{filtersItems && (
				<TariffsFilterContainer filters={filtersItems} onMobileResetButtonClick={resetFilters} />
			)}
			<Container>
				{isTariffsLoading ? (
					<FiltersTariffsStub />
				) : tariffs.length ? (
					<ShouldAddConvergentProvider value={true}>
						<MobileTariffList
							// TODO: rework key using to component decomposition or additional route
							key={params.tagCode}
							tariffs={tariffs}
							text={text}
							isRatesMobileRegion={true}
						/>
					</ShouldAddConvergentProvider>
				) : (
					<ResetFiltersBlock text={text} onResetClick={resetFilters} />
				)}
				{tariffs.length < totalTariffs && (
					<ShowMoreButton
						disabled={isTariffsLoading}
						windowSizes={windowSizes}
						text={text}
						onClickHandler={fetchMoreTariffs}
					/>
				)}
			</Container>
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"), withDefaultParams, withRouter)(Tariffs);
